<template>
  <div class="colorful-background wrapper-grid special">
    <div
      :class="[
        'title ',
        { animate__animated: isFirst },
        'animate__flipInX ',
        'text-align-left',
      ]"
    >
      <span class="small-font">
        上个学期课时最多的课是
      </span>
      <span class="middle-font">
        {{ schedule_statistics.Most.Schedule.COURSE }}
      </span>
    </div>

    <div
      :class="['text', { animate__animated: isFirst }, ' animate__fadeIn']"
      style="align-items: flex-end;"
    >
      <span class="small-font">
        总计
      </span>
      <span class="middle-font">
        {{ schedule_statistics.Most.Num }}<span class="middle-font">课时</span>
      </span>
      <span class="small-font">
        约合
      </span>
      <span class="middle-font is-inline">
        {{ (schedule_statistics.Most.Num * 45) / 60
        }}<span class="middle-font">小时</span>
      </span>
    </div>

    <div
      :class="[
        'slogan',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'middle-margin-top',
      ]"
    >
      <span class="small-font is-block">
        您的身影最常出现于
      </span>
      <span class="small-font is-block">
        {{ schedule_statistics.Most.Schedule.CLASSROOM }}
      </span>
      <span class="small-font is-block">
        在那里 迷醉于知识的海洋
      </span>
    </div>

    <div :class="['img', { animate__animated: isFirst }, 'animate__fadeIn']">
      <image-box class="image-box-position" img-u-r-l="/pic/1.png"></image-box>
    </div>

    <div class="footer middle-margin-bottom">
      <div class="very-small-font">
        课程数据由杭电教务处提供,分析数据均在理想状态下计算
      </div>
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'

export default {
  name: 'mostClassPage',
  components: { ImageBox },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  computed: {
    schedule_statistics: function () {
      return store.state.$data.data.Schedule.Statistics
    },
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--second-delay);
  /*animation-duration: var(--defalut-continue);*/
}

.text.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--fourth-delay);
  animation-duration: var(--defalut-continue);
}
.wrapper-grid.special {
  --angle: 45deg;
  --first-color: var(--hdu-school-blue);
  --page-background-color: var(--hdu-school-blue);
  --second-color: var(--beautiful-blue);
  grid-template-rows: 5vh repeat(4, minmax(auto, auto)) 1fr 5vh;
  grid-template-areas:
    '. .      .'
    '. img    .'
    '. title  .'
    '. text   .'
    '. slogan .'
    '. .      .'
    '. footer .';
}
</style>
